import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createRolePermissionAsync, getAllPermissionsAsync } from '@application/features/rolepermission/rolepermissionThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import VnButton from '@ui/components/VnButton';
import VnValidation from '@ui/components/VnValidation';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import AddRolePermissionTable from './AddRolePermissionTable';
import { RoleCategory, RoleCategoryMap } from '@application/common/enums/role-category';
import Select from 'react-select';
import { selectStyles } from '@ui/styles/select-style';
const AddRolePermissionForm = ({ onClose }) => {
    const dispatch = useAppDispatch();
    const { permissions } = useAppSelector((state) => state.rolepermission);
    const [rolePermissions, setRolePermissions] = useState([]);
    const { setValue, handleSubmit, register, control, formState: { errors } } = useForm({
        defaultValues: {}
    });
    useEffect(() => {
        dispatch(getAllPermissionsAsync())
            .unwrap()
            .then((data) => {
            setRolePermissions(data);
        });
    }, []);
    function updateRolePermission(id, newPermissionType, isChecked) {
        const updatedPermissions = rolePermissions.map((permission) => {
            if (permission.id === id) {
                switch (newPermissionType) {
                    case PermissionType.Create:
                        if (isChecked) {
                            return {
                                ...permission,
                                create: isChecked,
                                read: isChecked,
                                update: isChecked
                            };
                        }
                        else {
                            return {
                                ...permission,
                                create: isChecked,
                                read: isChecked,
                                update: isChecked
                            };
                        }
                    case PermissionType.Read:
                        return { ...permission, read: isChecked };
                    case PermissionType.Update:
                        if (isChecked) {
                            return {
                                ...permission,
                                create: isChecked,
                                read: isChecked,
                                update: isChecked
                            };
                        }
                        else {
                            return {
                                ...permission,
                                create: isChecked,
                                read: isChecked,
                                update: isChecked
                            };
                        }
                    case PermissionType.Delete:
                        if (isChecked) {
                            return {
                                ...permission,
                                create: isChecked,
                                read: isChecked,
                                update: isChecked,
                                delete: isChecked
                            };
                        }
                        else {
                            return {
                                ...permission,
                                create: isChecked,
                                read: isChecked,
                                update: isChecked,
                                delete: isChecked
                            };
                        }
                    default:
                        return permission;
                }
            }
            //  else if (permission.parentId && permission.id === id) {
            //     switch (newPermissionType) {
            //         case PermissionType.Create:
            //             return { ...permission, read: isChecked, create: isChecked, update: isChecked };
            //         case PermissionType.Read:
            //             return { ...permission, read: isChecked };
            //         case PermissionType.Update:
            //             return { ...permission, read: isChecked, create: isChecked, update: isChecked };
            //         case PermissionType.Delete:
            //             return { ...permission, read: isChecked, create: isChecked, update: isChecked, delete: isChecked };
            //         default:
            //             return permission;
            //     }
            // }
            return permission;
        });
        const updatePermissionschildren = updatedPermissions.map((rolepermission) => {
            if (rolepermission?.parentId === id) {
                switch (newPermissionType) {
                    case PermissionType.Create:
                        return { ...rolepermission, read: isChecked, create: isChecked, update: isChecked };
                    case PermissionType.Read:
                        return { ...rolepermission, read: isChecked };
                    case PermissionType.Update:
                        return { ...rolepermission, read: isChecked, create: isChecked, update: isChecked };
                    case PermissionType.Delete:
                        return { ...rolepermission, read: isChecked, create: isChecked, update: isChecked, delete: isChecked };
                    default:
                        return rolepermission;
                }
            }
            return rolepermission;
        });
        const updateWorkOrderPermissions = updatePermissionschildren.map((rolepermission) => {
            if (id === Permission.WERKORDER && rolepermission.id === Permission.WERKORDER) {
                return { ...rolepermission, read: true };
            }
            else if (id === Permission.BEHEER && rolepermission.id === Permission.BEHEER) {
                return { ...rolepermission, read: isChecked, create: isChecked, update: isChecked, delete: isChecked };
            }
            else if (id === Permission.WPPLANNING && rolepermission.id === Permission.WPPLANNING) {
                return { ...rolepermission, read: isChecked, create: isChecked, update: isChecked, delete: isChecked };
            }
            return rolepermission;
        });
        const currentItem = updatedPermissions.filter((x) => x.id === id);
        const disableParentonDeleteIfChildDeleteDisabled = updateWorkOrderPermissions.map((rolepermission) => {
            if (rolepermission?.id === currentItem[0].parentId) {
                switch (newPermissionType) {
                    case PermissionType.Delete:
                        return { ...rolepermission, delete: false };
                    default:
                        return rolepermission;
                }
            }
            return rolepermission;
        });
        setRolePermissions(disableParentonDeleteIfChildDeleteDisabled);
    }
    const roleCategoryList = [];
    Object.keys(RoleCategory)
        .filter((v) => isNaN(Number(v)))
        .forEach((key, index) => {
        roleCategoryList.push({ label: RoleCategoryMap.get(index), value: index.toString() });
    });
    const [roleCategory, setRoleCategoryType] = useState(roleCategoryList[0]);
    const handlecontractLanguageChange = (option) => {
        setRoleCategoryType(option);
    };
    const onSubmit = (data) => {
        data.permission = rolePermissions;
        data.roleCategoryId = parseInt(roleCategory.value);
        dispatch(createRolePermissionAsync(data))
            .unwrap()
            .then(() => {
            onClose();
        });
    };
    return (_jsx(_Fragment, { children: _jsx("div", { className: 'mt-4', children: _jsxs("form", { onSubmit: handleSubmit(onSubmit), className: 'Vn-form-FormMain', noValidate: true, children: [_jsxs("div", { className: 'row', children: [_jsxs("div", { className: 'col-sm-8 col-md-8', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Rolnaam" }), _jsx("input", { type: 'text', className: 'form-control vn-Input', placeholder: 'Voer voornaam in', ...register('roleName', {
                                            required: 'Dit veld is verplicht'
                                        }) }), _jsx(VnValidation, { fieldError: errors.roleName })] }), _jsxs("div", { className: 'col-sm-4 col-md-4', style: { zIndex: 10 }, children: [_jsx("label", { className: 'form-label vn-text-label', children: "Rol Categorie" }), _jsx(Controller, { name: 'roleCategoryId', control: control, 
                                        // rules={{ required: 'Dit veld is verplicht' }}
                                        render: ({ field: { onChange, value } }) => (_jsx(Select, { placeholder: 'Selecteer Rol Categorie', isSearchable: false, styles: selectStyles, value: roleCategoryList?.find((option) => option.value === roleCategory.value), options: roleCategoryList, onChange: (selectedValue) => {
                                                handlecontractLanguageChange(selectedValue);
                                            } })) })] })] }), _jsx("br", {}), permissions && (_jsx("div", { style: { zIndex: 0 }, children: _jsx(AddRolePermissionTable, { permissions: rolePermissions, updateRolePermission: updateRolePermission }) })), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsxs("div", { style: { display: 'flex', marginLeft: 'auto' }, children: [_jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', onClick: onClose, type: 'button', children: "Annuleren" }), _jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', children: "Opslaan" })] }) })] }) }) }));
};
export default AddRolePermissionForm;
